import * as React from "react";
import FormaParteContainer from "../conteiners/formaparte-container";

export default function FormaPartePage() {
  return <FormaParteContainer></FormaParteContainer>;
}
